import { render, staticRenderFns } from "./AddJurisdictions.vue?vue&type=template&id=43cf83be&scoped=true"
import script from "./AddJurisdictions.vue?vue&type=script&lang=js"
export * from "./AddJurisdictions.vue?vue&type=script&lang=js"
import style0 from "./AddJurisdictions.vue?vue&type=style&index=0&id=43cf83be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cf83be",
  null
  
)

export default component.exports